import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Component from 'flarum/common/Component';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import Separator from './Separator';
import Avatar from 'flarum/common/components/Avatar';
import formatNumber from 'flarum/common/utils/formatNumber';
import humanTime from 'flarum/common/utils/humanTime';
import listItems from 'flarum/common/helpers/listItems';

/**
 * The `Sidebar` component displays sidebar on the Forum Application.
 */
export default class Sidebar extends Component {
  view() {
    const user = app.session.user;
    if (app.forum.attribute('showSideNavToGuests') === false && !user) return;
    const navItems = IndexSidebar.prototype.navItems();
    return m("div", {
      class: "App-sidebar-container"
    }, m("div", {
      class: "App-sidebar-user-block"
    }, user ? [m("div", {
      className: "loggedIn"
    }, m("div", {
      class: "avatarWrapper"
    }, m("div", {
      className: "Avatar-container"
    }, m(Avatar, {
      user: user
    }), m("ul", {
      className: "badges"
    }, listItems(user.badges().toArray())))), m("h4", null, user.username()), m("p", null, app.translator.trans('core.forum.user.joined_date_text', {
      ago: humanTime(user.joinTime())
    })), m("div", {
      class: "App-sidebar-user-stats"
    }, m("div", {
      class: "statItem"
    }, m("span", null, app.translator.trans('core.forum.user.posts_link')), m("span", null, formatNumber(user.commentCount()))), m("div", {
      class: "statItem"
    }, m("span", null, app.translator.trans('core.forum.user.discussions_link')), m("span", null, formatNumber(user.discussionCount())))))] : [m("div", {
      className: "guest"
    }, m("h4", {
      className: "guestGreeting"
    }, app.translator.trans('madeyedeer-pallet-theme.forum.howdy')), m("p", {
      className: "guestMessage"
    }, app.translator.trans('madeyedeer-pallet-theme.forum.involve')), m("div", {
      className: "guestButtons"
    }, this.sessionItems().toArray()))]), m("div", {
      class: "App-sidebar-items"
    }, m("div", {
      class: "App-sidebar-items-container"
    }, m("ul", null, listItems(navItems.toArray()), user ? listItems(this.sessionItems().toArray()) : ''))));
  }

  /**
   * Build an item list for users or visitors.
   *
   * @return {ItemList}
   */
  sessionItems() {
    const items = new ItemList();
    const user = app.session.user;
    if (user) {
      items.add('separator-top', Separator.component(), 50);
      items.add('profile', LinkButton.component({
        icon: 'fas fa-user',
        href: app.route.user(user)
      }, app.translator.trans('core.forum.header.profile_button')), 40);
      items.add('settings', LinkButton.component({
        icon: 'fas fa-cog',
        href: app.route('settings')
      }, app.translator.trans('core.forum.header.settings_button')), 30);
      items.add('separator', Separator.component(), 25);
      if (app.forum.attribute('adminUrl')) {
        items.add('administration', LinkButton.component({
          icon: 'fas fa-wrench',
          href: app.forum.attribute('adminUrl'),
          target: '_blank'
        }, app.translator.trans('core.forum.header.admin_button')), 20);
      }
      items.add('logOut', LinkButton.component({
        icon: 'fas fa-sign-out-alt',
        onclick: app.session.logout.bind(app.session)
      }, app.translator.trans('core.forum.header.log_out_button')), 10);
    } else {
      if (app.forum.attribute('allowSignUp')) {
        items.add('signUp', Button.component({
          className: 'Button Button--secondary Button--block',
          onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
        }, app.translator.trans('core.forum.header.sign_up_link')), 20);
      }
      items.add('logIn', Button.component({
        className: 'Button Button--secondary Button--block',
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
      }, app.translator.trans('core.forum.header.log_in_link')), 10);
    }
    return items;
  }
}
flarum.reg.add('madeyedeer-pallet-theme', 'forum/components/Sidebar', Sidebar);